<app-form-input
[parentForm]="parentForm"
[disabled]="disabled"

[value]="envoi?.personneMorale"

[label]="step12.getpersonnemorale"
[type]="'text'" [rule]="'minSize_3|maxSize_1000'"
[errorMessage]="{'minLength' : 'ctr_36'}"
[name]="getUid()+'_SepAtt_personneMorale'">
</app-form-input>

<app-type-pers  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [personnePhysique]="envoi?.personnePhysique"></app-type-pers>

<app-type-adresse  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
[filtreRG]="'envoi'"
[nbIteration]="0"
 [adr]="envoi?.adr"></app-type-adresse>

<app-type-coord  [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [coord]="envoi?.coord"></app-type-coord>

<app-form-input *ngIf="false"
[parentForm]="parentForm"
[disabled]="disabled"

[value]="envoi?.conditionsRemise"

[label]="'conditionsRemise'"
[type]="'text'" [rule]="'minSize_1|maxSize_2000'"
[name]="getUid()+'_SepAtt_conditionsRemise'">
</app-form-input>
<!--<app-form-input-error [activeForm]="parentForm" [name]="rg2"></app-form-input-error>-->



